

export const Payments = ({payment}) => {
    if (payment === 'undefined') return null;

    
    const items = Object.entries(payment).map(([method, value], index) => {
        return (
            Number(value.status) !== 0 &&
            <div key={index} className="form-check">
                <input className="form-check-input " type="radio" name="pay-methods" value={method} id={method} defaultChecked={index === 0 ? true : false}/>
                <label className="form-check-label fs-6 fw-bold" htmlFor={method}>
                    {value.name}
                </label>
            </div>
        );
    });

    return (
        <div className="form-group mb-5">
            <label className="form-label fs-6 fw-bold">Спосіб оплати</label><br/>
            {items}
        </div>
    )
}